var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_3717_877)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6.85356 0.000413496C7.76188 -0.00792436 8.66295 0.162727 9.50532 0.502623C10.3477 0.842519 11.1149 1.345 11.763 1.98139C12.4112 2.61777 12.9277 3.37559 13.283 4.21158C14.0006 5.89994 14.018 7.8042 13.3316 9.50544C12.6451 11.2067 11.311 12.5656 9.62264 13.2831C7.93428 14.0007 6.03002 14.0182 4.32878 13.3317C2.62754 12.6453 1.26866 11.3111 0.551096 9.62276C0.195793 8.78677 0.00862934 7.88898 0.000291426 6.98066C-0.00804643 6.07234 0.162605 5.17127 0.502501 4.3289C0.842397 3.48653 1.34488 2.71936 1.98127 2.07118C2.61765 1.423 3.37547 0.90652 4.21146 0.551218C5.04745 0.195915 5.94524 0.00875141 6.85356 0.000413496ZM8.85049 2.12549C8.22124 1.87159 7.54814 1.74411 6.86962 1.75034C6.1911 1.75657 5.52046 1.89638 4.89597 2.16179C4.27148 2.4272 3.70539 2.81302 3.23001 3.29721C2.75463 3.7814 2.37927 4.35448 2.12537 4.98373C1.87147 5.61298 1.74399 6.28608 1.75022 6.9646C1.75645 7.64312 1.89626 8.31377 2.16167 8.93825C2.69769 10.1995 3.71277 11.1961 4.98361 11.7089C6.25444 12.2216 7.67692 12.2086 8.93813 11.6726C10.1993 11.1365 11.1959 10.1214 11.7087 8.85061C12.2215 7.57978 12.2085 6.1573 11.6724 4.89609C11.407 4.27161 11.0212 3.70551 10.537 3.23013C10.0528 2.75475 9.47974 2.37939 8.85049 2.12549Z",
            fill: "#8B8A94",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M10.6313 10.6314C10.973 10.2897 11.527 10.2897 11.8687 10.6314L15.6187 14.3814C15.9604 14.7231 15.9604 15.2771 15.6187 15.6188C15.277 15.9605 14.723 15.9605 14.3813 15.6188L10.6313 11.8688C10.2895 11.5271 10.2895 10.9731 10.6313 10.6314Z",
            fill: "#8B8A94",
          },
        }),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_3717_877" } }, [
          _c("rect", { attrs: { width: "16", height: "16", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }